import { ProductProps } from '@repo/ui/src/types';

export enum RibbonTypeEnum {
  New = 'New',
  Sale = 'On Sale',
  OutOfStock = 'Out of Stock',
  FreeBundle = 'Free Bundle',
  ComingSoon = 'Coming Soon',
}
export const getRibbonText = (
  { isNewProduct, discount, isOrderable, ctaButtonType, isComingSoon }: ProductProps,
  newText?: string,
  saleText?: string,
  outOfStockText?: string,
  comingSoonText?: string,
): string | null => {
  if (isComingSoon) {
    return comingSoonText || RibbonTypeEnum.ComingSoon;
  }
  if (!isOrderable && ctaButtonType !== 'shopLocal' && ctaButtonType !== 'noCTA') {
    return outOfStockText || RibbonTypeEnum.OutOfStock;
  }
  if (discount > 0) {
    return saleText || RibbonTypeEnum.Sale;
  }
  if (isNewProduct) {
    return newText || RibbonTypeEnum.New;
  }
  return null;
};
